import { useState } from "react";
import { Grid, Group, Stack, Text } from "@mantine/core";
import { TestType, TumblingEResultData, VAcuityTestResult } from "types/testTypes";

import TumblingETestEntry from "./TumblingETestEntry";
import {
  getVaSnellenString,
  getVaDisplayLabel,
  VisualAcuityNotation,
} from "@utils/test-specific-utils/VisualAcuityUtils";
import VAcuityResultLine from "../../common/VAcuityResultLine";
import VisualAcuityNotationSelector from "@components/testContainer/common/VisualAcuityNotationSelector";

export default function VAcuityTestEntry({ entry }) {
  const [notation, setNotation] = useState<VisualAcuityNotation>(
    VisualAcuityNotation.SnellenDecimal,
  );
  const testResult = entry as VAcuityTestResult;
  const isTestTumblingE =
    testResult.testType === TestType.TumblingE ||
    testResult.testType === TestType.TumblingEThreshold;
  const snellenAcuity = getVaSnellenString(testResult);
  const formattedAcuity = getVaDisplayLabel(testResult, notation);
  const finalAcuityLabel =
    snellenAcuity && formattedAcuity && formattedAcuity !== snellenAcuity
      ? `${snellenAcuity} (${formattedAcuity})`
      : (snellenAcuity ?? formattedAcuity ?? "N/A");
  const tumblingEResult = (testResult.results as TumblingEResultData | undefined) ?? {
    responses: [],
  };

  return isTestTumblingE ? (
    <TumblingETestEntry result={tumblingEResult} />
  ) : (
    <Stack gap="sm">
      <Grid columns={16} align="center">
        <Grid.Col span={16}>
          <Group wrap="nowrap" gap={"sm"}>
            <Text fw={600}>{`Final Acuity: `}</Text>
            <Text>{finalAcuityLabel}</Text>
          </Group>
        </Grid.Col>
        {testResult?.values &&
          testResult.values.map((value, index) => (
            <VAcuityResultLine
              key={index}
              row={index}
              rowResults={value.results}
              isActive={false}
              letters={value.letters}
              value={value.value}
              isResultLine={index === testResult.values.length - 1}
              notation={notation}
            />
          ))}
      </Grid>
      <Group justify="center" className="no-print print-hide">
        <VisualAcuityNotationSelector value={notation} onChange={setNotation} />
      </Group>
    </Stack>
  );
}
